import React, { useState } from "react";
import { useFieldArray, useFormContext } from "react-hook-form";
import { Grid, IconButton, List, ListItem, TextField, Typography } from "@mui/material";
import TranslationWrapper, { getTranslation } from "../../../components/TranslationWrapper/TranslationWrapper";
import Card from "../../../components/Card/Card";
import CardBody from "../../../components/Card/CardBody";
import AsynchronousAutocomplete from "../../../components/Autocomplete/AsynchronousAutocomplete";
import Tooltip from "@mui/material/Tooltip";
import Button from "../../../components/CustomButtons/Button";
import { Link } from "react-router";
import Edit from "@mui/icons-material/Edit";
import { Delete, Lock } from "@mui/icons-material";
import FormElement from "../../../components/JamezzTable/FormElement";
import { useVestigingContext } from "../../../components/Forms/VestigingProvider";

export default function ChildOptionGroups() {
  const { control } = useFormContext();
  const { vestiging } = useVestigingContext();
  const appTarget = vestiging?.appTarget;
  const { fields, append, prepend, remove, swap, move, insert } = useFieldArray({
    control,
    name: "child_option_groups",
    keyName: "key",
  });

  if (appTarget !== "appv5.js") {
    return (
      <Card>
        <CardBody style={{ padding: 16 }}>
          <Typography>
            <Lock />
            <TranslationWrapper tKey={"Only supported in appv5"} />
          </Typography>
        </CardBody>
      </Card>
    );
  }

  return (
    <Card>
      <CardBody style={{ padding: 16 }}>
        <Grid container spacing={1}>
          <Grid item xs={12}>
            <List>
              <ListItem>
                <Grid container spacing={1}>
                  <Grid item xs={4}>
                    <TranslationWrapper tKey={"Option group name"} />
                  </Grid>
                  <Grid item xs={2}>
                    <TranslationWrapper tKey={"Sort key"} />
                  </Grid>
                  <Grid item xs={2}>
                    <TranslationWrapper tKey={"Min count"} />
                  </Grid>
                  <Grid item xs={2}>
                    <TranslationWrapper tKey={"Max count"} />
                  </Grid>
                  <Grid item xs={2} />
                </Grid>
              </ListItem>
              {fields.map((field, index) => {
                return (
                  <ListItem key={field.key}>
                    <Grid container spacing={1}>
                      <Grid item xs={4}>
                        <Typography style={{ margin: "0 16px" }}>
                          {field.id} {field.name}
                        </Typography>
                      </Grid>
                      <Grid item xs={2}>
                        {field.pivot ? (
                          <FormElement endPoint={"core/productOptionGroups"} name={"sort_key"} row={field.pivot}>
                            <TextField
                              label={field.sort_key}
                              placeholder={field.pivot?.sort_key ?? field.sort_key}
                              size={"small"}
                              variant={"standard"}
                            />
                          </FormElement>
                        ) : null}
                      </Grid>
                      <Grid item xs={2}>
                        {field.pivot ? (
                          <FormElement endPoint={"core/productOptionGroups"} name={"min_count"} row={field.pivot}>
                            <TextField
                              label={field.min_count}
                              placeholder={field.pivot?.min_count ?? field.min_count}
                              size={"small"}
                              variant={"standard"}
                            />
                          </FormElement>
                        ) : null}
                      </Grid>
                      <Grid item xs={2}>
                        {field.pivot ? (
                          <FormElement endPoint={"core/productOptionGroups"} name={"max_count"} row={field.pivot}>
                            <TextField
                              label={field.max_count}
                              placeholder={field.pivot?.max_count ?? field.max_count}
                              size={"small"}
                              variant={"standard"}
                            />
                          </FormElement>
                        ) : null}
                      </Grid>
                      <Grid item xs={2}>
                        <IconButton
                          onClick={() => {
                            remove(index);
                          }}
                        >
                          <Delete />
                        </IconButton>

                        <Link to={`/manager/optionGroups/${field.id}/edit`}>
                          <Tooltip
                            classes={{}}
                            placement={"bottom"}
                            title={
                              <TranslationWrapper
                                tDefault={"View Option Group"}
                                tKey={"global.jamezzTable.viewOptionGroup"}
                              />
                            }
                          >
                            <Button color={"success"} simple>
                              <Edit />
                            </Button>
                          </Tooltip>
                        </Link>
                      </Grid>
                    </Grid>
                  </ListItem>
                );
              })}
            </List>
          </Grid>
        </Grid>

        <AddChildOptionGroup append={append} />
      </CardBody>
    </Card>
  );
}

function AddChildOptionGroup({ append }) {
  const { register, vestigingId, menukaartVestigingId, reloadDataFromServer } = useFormContext();
  const [optionGroup, setOptionGroup] = useState(null);
  return (
    <>
      <AsynchronousAutocomplete
        async={{
          url: `core/optionGroups/search?fields=id as value,id,name as label,vestiging_id,name,sort_key&sort_field=name&sort_dir=asc&vestiging_id=${menukaartVestigingId}`,
          searchField: "name",
          perPage: 20,
          // extraFilters: { vestiging_id: { name: "vestiging_id", value: "vestiging_id" } },
        }}
        key={menukaartVestigingId}
        onChange={(e, option) => {
          setOptionGroup(option);
        }}
        placeholder={getTranslation("Find option group")}
        value={optionGroup}
      />
      <Button
        disabled={!optionGroup}
        onClick={() => {
          setOptionGroup(null);
          append(optionGroup);
        }}
      >
        <TranslationWrapper tKey={"Add option group"} />
      </Button>
    </>
  );
}
